"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentInfo = void 0;
const react_1 = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const types_1 = require("../../types");
const DisabledRelationshipWarning_1 = require("./DisabledRelationshipWarning");
const AppointmentPurpose_1 = require("./AppointmentPurpose");
const LocationFilter_1 = require("./LocationFilter");
const utils_1 = require("../lib/utils");
const utils_2 = require("../lib/utils");
const messages_1 = require("../lib/messages");
const styles_1 = require("../styles");
const constants_1 = require("../lib/constants");
const EmergencyDisclaimer_1 = __importDefault(require("./EmergencyDisclaimer/EmergencyDisclaimer"));
const patientRelMapping = {
    existing: constants_1.ESTABLISHED_PATIENT,
    new: constants_1.NEW_PATIENT
};
exports.AppointmentInfo = (0, intl_1.injectIntl)(({ appointmentInfo, disableLocationFilter, handleUpdateAvailability, intl, locations, log, provider, config, hidePatientRelationshipQuestions, patientRelationshipOptions, shouldHaveSimilarPatientRelationshipQuestion, onLocationChange, purposeOptionsByRelationship, resetAvailability, selectedLocation }) => {
    var _a;
    const initialPurpose = (0, utils_1.getInitialPurpose)(appointmentInfo, purposeOptionsByRelationship);
    const relationshipOptions = [
        {
            value: types_1.PatientRelationship.NEW,
            label: intl.formatMessage(messages_1.messages.newPatientLabel)
        },
        {
            value: types_1.PatientRelationship.ESTABLISHED,
            label: intl.formatMessage(messages_1.messages.establishedPatientLabel)
        }
    ];
    const [purpose, setPurpose] = (0, react_1.useState)(initialPurpose);
    const [relationship, setRelationship] = (0, react_1.useState)(appointmentInfo.relationship);
    const [visitMethodGroup, setVisitMethodGroup] = (0, react_1.useState)((0, utils_1.getVisitMethodGroup)(purpose === null || purpose === void 0 ? void 0 : purpose.visit_method));
    const visitMethodGroupsEnabled = (0, utils_1.getEnableVisitMethodGroups)(purposeOptionsByRelationship, relationship);
    const visitMethodGroupOptions = [
        {
            value: types_1.VisitMethodGroup.InPerson,
            label: intl.formatMessage(messages_1.messages.visitGroupInPerson)
        },
        {
            value: types_1.VisitMethodGroup.Virtual,
            label: intl.formatMessage(messages_1.messages.visitGroupVirtual)
        }
    ];
    const defaultAppointmentPurpose = (0, utils_1.getDefaultPurposes)(purposeOptionsByRelationship);
    const handleRelationshipChange = (_e, newRelationship) => {
        setRelationship(newRelationship);
        const newPurpose = defaultAppointmentPurpose != null &&
            defaultAppointmentPurpose[newRelationship] != null
            ? defaultAppointmentPurpose[newRelationship]
            : undefined;
        handlePurposeChange(newPurpose, newRelationship);
        (0, utils_2.logAppointmentInfoChange)(log, 'patient-type', newRelationship);
    };
    const handleVisitMethodGroupChange = (_e, newVisitMethodGroup) => {
        setVisitMethodGroup(newVisitMethodGroup);
        const defaultPurpose = defaultAppointmentPurpose != null &&
            defaultAppointmentPurpose[relationship] != null
            ? defaultAppointmentPurpose[relationship]
            : undefined;
        const newPurposeGroup = (0, utils_1.getVisitMethodGroup)(defaultPurpose === null || defaultPurpose === void 0 ? void 0 : defaultPurpose.visit_method);
        const newPurpose = newPurposeGroup === newVisitMethodGroup ? defaultPurpose : undefined;
        handlePurposeChange(newPurpose, relationship);
        (0, utils_2.logAppointmentInfoChange)(log, 'visit-method-group', newVisitMethodGroup);
    };
    const handlePurposeChange = (newPurpose, newRelationship = relationship) => {
        resetAvailability();
        setPurpose(newPurpose);
        if (newPurpose != null && newRelationship != null) {
            (0, utils_2.logAppointmentInfoChange)(log, 'appointment-purpose', (newPurpose === null || newPurpose === void 0 ? void 0 : newPurpose.name) || '');
            const newVisitMethodGroup = (0, utils_1.getVisitMethodGroup)(newPurpose.visit_method);
            setVisitMethodGroup(newVisitMethodGroup);
            handleUpdateAvailability({
                relationship: newRelationship,
                purpose: newPurpose.name
            });
        }
    };
    const getRelationshipOptions = (patientRelationshipOptions = []) => {
        if (patientRelationshipOptions.length > 0) {
            return patientRelationshipOptions.map(({ button_text, patient_type, disabled = false }) => ({
                value: patientRelMapping[patient_type],
                label: button_text,
                disabled: disabled
            }));
        }
        return [
            {
                value: constants_1.ESTABLISHED_PATIENT,
                label: intl.formatMessage(messages_1.messages.existingPatientButtonText)
            },
            {
                value: constants_1.NEW_PATIENT,
                label: intl.formatMessage(messages_1.messages.newPatientButtonText)
            }
        ];
    };
    const patientRelationshipQuestion = (_a = provider === null || provider === void 0 ? void 0 : provider.patient_rel_question) === null || _a === void 0 ? void 0 : _a[0];
    const patientRelationshipTitle = (patientRelationshipQuestion === null || patientRelationshipQuestion === void 0 ? void 0 : patientRelationshipQuestion.message)
        ? patientRelationshipQuestion.message
        : intl.formatMessage(messages_1.messages.patientRelTitle, {
            display_name: (0, utils_1.formatProviderName)(provider)
        });
    const purposesExist = (purposeOptionsByRelationship[relationship] || []).length > 0;
    (0, react_1.useEffect)(() => {
        const initialPurpose = (0, utils_1.getInitialPurpose)(appointmentInfo, purposeOptionsByRelationship);
        const visitMethod = (0, utils_1.getVisitMethodGroup)(initialPurpose === null || initialPurpose === void 0 ? void 0 : initialPurpose.visit_method);
        if (shouldHaveSimilarPatientRelationshipQuestion) {
            setRelationship((hidePatientRelationshipQuestions
                ? constants_1.ESTABLISHED_PATIENT
                : appointmentInfo.relationship));
        }
        setPurpose(initialPurpose);
        setVisitMethodGroup(visitMethod);
    }, [
        appointmentInfo,
        shouldHaveSimilarPatientRelationshipQuestion,
        hidePatientRelationshipQuestions,
        purposeOptionsByRelationship
    ]);
    const onCloseEmergencyDisclaimer = () => {
        log('user_action.provider_profile.appt_info.emergency_warning.close_warning');
    };
    const onClickEmergencyDisclaimer = (event) => {
        if (event.target && event.target.href) {
            log('user_action.provider_profile.appt_info.emergency_warning.warning_link');
        }
    };
    const patientRelationshipRadioGroup = shouldHaveSimilarPatientRelationshipQuestion ? (!hidePatientRelationshipQuestions && (react_1.default.createElement(styles_1.RadioButtonGroup, { buttonStyle: "secondary", "data-testid": "appt-info-patient-type-similar", legend: patientRelationshipTitle, mode: "buttons", name: "appt-info-patient-type", onChange: handleRelationshipChange, options: getRelationshipOptions(patientRelationshipOptions), row: true, selected: relationship }))) : (react_1.default.createElement(styles_1.RadioButtonGroup, { buttonStyle: "secondary", "data-testid": "appt-info-patient-type", legend: intl.formatMessage(messages_1.messages.patientRelationshipLabel), mode: "buttons", name: "appt-info-patient-type", onChange: handleRelationshipChange, options: relationshipOptions, row: true, selected: relationship }));
    return (react_1.default.createElement(styles_1.AppointmentInfoContainer, { "data-testid": "booking-appointment-info" },
        react_1.default.createElement(EmergencyDisclaimer_1.default, { "data-testid": "appt-info-emergency-disclaimer", config: config, onClose: onCloseEmergencyDisclaimer, onClick: onClickEmergencyDisclaimer }),
        patientRelationshipRadioGroup,
        purposesExist === false && relationship && (react_1.default.createElement(DisabledRelationshipWarning_1.DisabledRelationshipWarning, { purposeOptionsByRelationship: purposeOptionsByRelationship })),
        purposesExist === true && (react_1.default.createElement(react_1.default.Fragment, null,
            visitMethodGroupsEnabled && (react_1.default.createElement(styles_1.RadioButtonGroup, { buttonStyle: "secondary", "data-testid": "appt-info-visit-method-group", legend: intl.formatMessage(messages_1.messages.visitMethodLabel), mode: "buttons", name: "appt-info-visit-method-group", onChange: handleVisitMethodGroupChange, options: visitMethodGroupOptions, row: true, selected: visitMethodGroup })),
            react_1.default.createElement(AppointmentPurpose_1.AppointmentPurpose, { initialPurpose: purpose, onChange: handlePurposeChange, purpose: purpose, purposeOptionsByRelationship: purposeOptionsByRelationship, relationship: relationship, visitMethodGroup: visitMethodGroup }),
            locations && locations.length > 1 && (react_1.default.createElement(LocationFilter_1.LocationFilter, { disabled: disableLocationFilter, locations: locations, selectedLocation: selectedLocation, log: log, onChange: onLocationChange }))))));
});
//# sourceMappingURL=AppointmentInfo.js.map